<template>
  <v-app
    id="dashboard"
    :style="{
      filter: needPayment.flag ? 'blur(5px)' : null,
      background: $route.name === 'webinarSignUp' ? '#003865' : null,
    }"
  >
    <TopBar
      :need-payment="needPayment.flag"
      :class="needPayment.flag ? 'paymentBlock' : null"
    />
    <v-main>
      <v-container
        class="pt-10 mb-5"
        style="max-width: 1124px;"
        fluid
      >
        <v-row
          align="center"
          justify="center"
          class="mx-0"
        >
          <v-fade-transition mode="out-in">
            <router-view :class="needPayment.flag ? 'paymentBlock' : null" />
          </v-fade-transition>
        </v-row>
      </v-container>
    </v-main>

    <PaymentInformation
      v-if="needPayment.flag"
      :dialog="needPayment.flag"
      :option="needPayment.option"
    />

    <CertifiedNeededModal />

    <v-fab-transition>
      <v-btn
        v-if="showGroove"
        color="primary"
        fab
        outlined
        dark
        fixed
        bottom
        right
        class="v-btn--example"
        style="border-width: 4px;"
        @click="openGroove"
      >
        <v-icon>mdi-help</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import TopBar from './layout/TopBar.vue';
import PaymentInformation from './layout/PaymentInformation.vue';
import CertifiedNeededModal from './layout/widget/CertifiedNeededModal.vue';

export default {
  components: {
    TopBar,
    PaymentInformation,
    CertifiedNeededModal,
  },

  data: () => ({
    showGroove: false,
  }),

  computed: {
    ...mapState({
      user: (state) => state.account.user,
      darkMode: (state) => state.displaySettings.darkMode,
      isBlur: (state) => state.account.blur,
    }),

    needPayment() {
      const blur = {
        flag: this.isBlur,
        option: 'register',
      };
      if (this.isBlur) {
        if ((this.user
          && typeof this.user.is_tos_agreed === 'boolean' && !this.user.is_tos_agreed)) {
          blur.option = 'tos';
        }
      }
      return blur;
    },
  },

  watch: {
    darkMode: {
      immediate: true,
      handler(newValue) {
        this.$vuetify.theme.dark = newValue;
      },
    },
  },

  mounted() {
    // groovehq
    // if (window.groove && this.user) {
    //   window.groove.widget('setWidgetId', '07c22114-1c50-6ddf-e01a-a946096c9488');
    //   window.groove.widget('load');
    //   window.groove.widget('setCustomer', {
    //     email: this.user.email,
    //   });

    //   setTimeout(() => {
    //     this.showGroove = true;
    //   }, 700);
    // } else {
    //   window.groove.widget('unload');
    // }
  },

  beforeDestroy() {
    // if (window.groove) {
    //   window.groove.widget('unload');
    // }
    // this.showGroove = false;
  },

  methods: {
    openGroove() {
      if (window.groove) {
        window.groove.widget('open');
      }
    },
  },
};
</script>

<style lang="scss">
.paymentBlock {
  pointer-events: none;
}

.grv-widget-tag-bottom-right {
  // hide the groove button without hiding form
  // display: none also hide hide the form;hidethegroovebuttonwithouthidingformdisplay

  position: absolute;
  top: 0;
  right: -100vw !important;
}
</style>
